import { DocumentsApi } from '@element451-libs/models451';

export const ALLOWED_MULTI_FILE_EXTS =
  DocumentsApi.MULTI_DOCUMENT_SUPPORTED_EXTENSIONS;
